import { render, staticRenderFns } from "./UpcomingAmountPopover.vue?vue&type=template&id=21bd7505&scoped=true"
import script from "./UpcomingAmountPopover.vue?vue&type=script&lang=js"
export * from "./UpcomingAmountPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd7505",
  null
  
)

export default component.exports